const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonAdd(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "language_icon_svg__linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 84.07,
    y1: 203.58,
    x2: 751.14,
    y2: 203.58,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%,56.470588%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%,83.137255%,94.901961%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "language_icon_svg__linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 90.06,
    y1: 203.58,
    x2: 745.19,
    y2: 203.58,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%,56.470588%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%,83.137255%,94.901961%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "person_add_svg__bo"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 64,
    width: 304.04,
    height: 301.16,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 70,
    width: 292.04,
    height: 289.16,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "person_add_svg__dr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m268.12,215.75c-7.29-1.79-14.83-2.71-22.4-2.71h-90c-51.68,0-93.72,42.04-93.72,93.72v11.88c0,6.62,5.38,12,12,12h157.56c6.62,0,12-5.38,12-12s-5.38-12-12-12H86c.06-38.39,31.32-69.6,69.72-69.6h90c5.71,0,11.39.69,16.88,2.06,1.14.29,2.15.34,2.81.36h.19c3.18-.02,6.16-1.27,8.41-3.51,2.27-2.27,3.52-5.28,3.52-8.49s-1.25-6.22-3.51-8.48c-1.62-1.62-3.65-2.73-5.88-3.23Z",
    style: {
      fill: "#f7f7f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m270.96,134.68c0-38.97-31.71-70.68-70.68-70.68s-70.68,31.71-70.68,70.68,31.71,70.68,70.68,70.68,70.68-31.71,70.68-70.68Zm-70.68,46.68c-25.74,0-46.68-20.94-46.68-46.68s20.94-46.68,46.68-46.68,46.68,20.94,46.68,46.68-20.94,46.68-46.68,46.68Z",
    style: {
      fill: "url(#language_icon_svg__linear0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m322.28,276.32h-20.64v-20.64c0-6.62-5.38-12-12-12s-12,5.38-12,12v20.64h-20.64c-6.62,0-12,5.38-12,12s5.38,12,12,12h20.64v20.64c0,6.62,5.38,12,12,12s12-5.38,12-12v-20.64h20.64c6.62,0,12-5.38,12-12s-5.38-12-12-12Z",
    style: {
      fill: "url(#language_icon_svg__linear0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m289,211.08c-42.48,0-77.04,34.56-77.04,77.04s34.56,77.04,77.04,77.04,77.04-34.56,77.04-77.04-34.56-77.04-77.04-77.04Zm0,130.08c-29.25,0-53.04-23.79-53.04-53.04s23.79-53.04,53.04-53.04,53.04,23.79,53.04,53.04-23.79,53.04-53.04,53.04Z",
    style: {
      fill: "url(#language_icon_svg__linear0)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonAdd);
export default __webpack_public_path__ + "static/media/person_add.4193382335385eead84348fbc93f8623.svg";
export { ForwardRef as ReactComponent };